import getUrlParameter from "../header/components/getUrlParameter";
import reCaptchaOnFocus from "./reCaptchaOnFocus";
export default function recaptcha() {
  getUrlParameter();
  $(function () {
    if (document.getElementById('remember-email')) {
      document.getElementById('remember-email').addEventListener('focus', reCaptchaOnFocus, false);
    }

    if (document.getElementById('tbxName')) {
      document.getElementById('tbxName').addEventListener('focus', reCaptchaOnFocus, false);
    }
    if (document.getElementById('tbxEmail')) {
      document.getElementById('tbxEmail').addEventListener('focus', reCaptchaOnFocus, false);
    }
    if (document.getElementById('tbxComment')) {
      document.getElementById('tbxComment').addEventListener('focus', reCaptchaOnFocus, false);
    }
  })

  window.captchaCallback = function () {
    InitCaptchaForgotPassword();
    if ($("#contactUsReCaptcha").length) {
      if (typeof (window.ContactUsReCaptchaId) == "undefined") {

        window.ContactUsReCaptchaId = grecaptcha.render('contactUsReCaptcha', {
          'sitekey': '6LdoeBYTAAAAAMx1DGDnVRodjFoBIzytO0UI9oxY'
        });
      }
    }
  }

  function InitCaptchaForgotPassword() {
    if ($("#forgotPasswordReCaptcha").length
      && typeof (window.ForgotPasswordRecaptchaPageId) == "undefined") {

      window.ForgotPasswordRecaptchaPageId = grecaptcha.render('forgotPasswordReCaptcha', {
        'sitekey': '6LdoeBYTAAAAAMx1DGDnVRodjFoBIzytO0UI9oxY'
      });
    }

    if (getUrlParameter("completeRegistrationEvent")) {
      if (typeof (fbq) != 'undefined') { fbq('track', 'CompleteRegistration'); }
      if (window.history != undefined && window.history.pushState != undefined) {
        window.history.pushState({}, document.title, removeParam("completeRegistrationEvent", window.location.href));
      }
    }
  }
  
  jQuery.loadScript = function (url, callback) {
    jQuery.ajax({
      url: url,
      dataType: 'script',
      success: callback,
      async: true
    });
  }
}